import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  SideBarCard,
  SideBarCardData
} from '../StyledComponents/StyledSideBar';
import {
  Title,
  AuthorAndTime,
  ListElement,
  StyledLine,
  StyledLineInside,
  CardHolder,
  FlexContainer,
  Rating
  // Image
} from '../StyledComponents';
import { rootConfig } from '../../../config/config';
import MainListLoader from '../Loaders/MainListLoader';

const List_S_Image = props => {
  const { title, listItems } = props;
  let cardItems = null;
  if (listItems) {
    cardItems = listItems.map(listItem => (
      <SideBarCard
        key={listItem.id}
        onClick={() => navigate(listItem.postSlug)}
      >
        <div className="ImageDiv relative">
          {listItem.rating ? (
            <FlexContainer className="Rating">
              <Rating
                className="absolute right-0"
                width="50px"
                height="50px"
                padding="12px"
                background="#4db2ec"
              >
                <Title
                  className="Rating-Text"
                  fontFamily="Montserrat"
                  fontSize="2.25rem"
                  color="#fff"
                >
                  {listItem.rating}
                </Title>
              </Rating>
            </FlexContainer>
          ) : null}
          <div
            style={{
              // width: '225px',
              width: '100%',
              height: '112.5px',
              // background: `url(${rootConfig.imagesRoot}/${
              //   listItem.featuredImage.file
              // })`,
              background: `${
                listItem.featuredImage
                  ? `url(${rootConfig.imagesRoot}/${
                      listItem.featuredImage.file
                    })`
                  : 'black'
              }`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
          {/* <Image
          src={
            listItem.featuredImage
              ? `${rootConfig.imagesRoot}/${listItem.featuredImage.file}`
              : null
          }
          alt={listItem.postSlug}
        /> */}
        </div>
        <SideBarCardData>
          <Title
            fontFamily="Nunito"
            fontSize="1rem"
            fontWeight="bold"
            lineHeight="1.4"
            padding="0.5rem 0 0 0"
          >
            {listItem.postTitle}
          </Title>
          <AuthorAndTime
            color="#757575"
            fontFamily="Montserrat"
            fontSize="0.75rem"
            fontWeight="normal"
          >
            <div>{listItem.postAuthor.authorName}</div>
            <div>{listItem.postDate}</div>
          </AuthorAndTime>
        </SideBarCardData>
      </SideBarCard>
    ));
  }

  const navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    props.history.push(`/${postSlug}`);
  };

  return (
    <ListElement className="w-100 pa3">
      <Title fontFamily="Montserrat" fontSize="1.5rem" fontWeight="bold">
        {title}
      </Title>
      <StyledLine>
        <StyledLineInside />
      </StyledLine>
      <CardHolder>
        {cardItems !== null ? cardItems : <MainListLoader />}
      </CardHolder>
    </ListElement>
  );
};

export default withRouter(List_S_Image);
